<template>
  <svg :class="mailClass" class="mail-icon" :width="width" :height="height" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M23.588 0H0v16h24V0h-.412zM8.278 7.806l3.777 3.262 3.563-3.088 6.892 7.12H1.217l7.061-7.293zM.873 14.18V1.413l6.733 5.812L.873 14.18zm15.416-6.781 6.838-5.925v12.988L16.29 7.399zM22.432.9 12.054 9.89 1.64.9h20.79z" />
  </svg>
</template>

<script>
export default {
  name: 'Mail',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    width: {
      type: [Number, String],
      default: 25,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
  computed: {
    mailClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>

<style lang="scss" scopped>
  .mail-icon {
    display: block;
    width: 23px;
    height: 18px;
  }
</style>
